<template>
    <b-container fluid="">
        <button type="button" class="btn btn-sm btn-outline-dark boton_agregar_formula"
            v-if="permisos['inventarios.rayo.promociones']?.crear || datos_usuario.parametros.roles.includes('ROOT')"
            @click="abrir_modal_formulario()"><i class="fas fa-plus"></i>
            Agregar</button>
        <button type="button" class="btn btn-sm btn-outline-dark boton_agregar_formula" v-else disabled>
            <i class="fas fa-plus"></i> Agregar
        </button>
        <b-row>
            <div class="col-sm-12 mt-1">
                <h3>
                    Promoción
                </h3>
            </div>
            <div v-if="ES_ROOT" class="col-sm-12 mt-2">
                <label for="" class="form-label">Sucursales</label>
                <select class="form-control form-control-sm" v-model="sucursales_select">
                    <option value="">Seleccionar</option>
                    <option v-for="(item, index) in sucursales" :key="index" :value="item.codigo">{{ item.nombre }}
                    </option>
                </select>
            </div>
            <div class="col-sm-12 mt-3">
                <div class="marco_formulas">
                    <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                        <thead>
                            <tr>
                                <th style="width: 20%">
                                    Código
                                </th>
                                <th style="width: 42%;">
                                    Descripción
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    Ubicación
                                </th>
                                <th style="width: 8%;text-align: center;">
                                    Activo
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in PROMOCIONES_FITLTRADAS" :key="index">
                                <td>
                                    {{ item.codigo }}
                                </td>
                                <td>
                                    {{ item.nombre }}
                                </td>
                                <td style="text-align: center;">
                                    {{ obtenerNombreSucursal(item.sucursal) }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.activo ? 'Si' : 'No' }}
                                </td>
                                <td style="text-align: center;">
                                    <button type="button" style="font-size: 10px;margin-right: 5px;"
                                        v-if="permisos['inventarios.rayo.promociones']?.actualizar || datos_usuario.parametros.roles.includes('ROOT')"
                                        class="btn btn-sm btn-outline-dark" @click="abrir_modal_editar(item)">
                                        <i class="fas fa-pen"></i>
                                    </button>
                                    <button type="button" style="font-size: 10px;margin-right: 5px;" v-else
                                        class="btn btn-sm btn-outline-dark" disabled>
                                        <i class="fas fa-pen"></i>
                                    </button>

                                    <button type="button" style="font-size: 10px;"
                                        v-if="permisos['inventarios.rayo.promociones']?.borrar || datos_usuario.parametros.roles.includes('ROOT')"
                                        class="btn btn-sm btn-outline-dark" @click="eliminar_formula(item)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                    <button type="button" style="font-size: 10px;" v-else
                                        class="btn btn-sm btn-outline-dark" disabled>
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-row>
        <Formulario v-if="modal_formulario" v-on:salir="cerrar_modal_formulario" />
        <Editar v-if="modal_editar" :item="item" v-on:salir="cerrar_modal_editar" />
    </b-container>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Formulario from './Formulario.vue'
    import Editar from './Editar.vue'
    import { pregunta } from '@/components/functions/alertas';
    export default {
        name: 'ListadoFormulas',
        components: {
            Formulario,
            Editar
        },
        computed: {
            ...mapState(['sucursales', 'permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT', 'PROMOCIONES_FITLTRADAS']),
            sucursales_select: {
                get() {
                    return this.$store.state.filtro_sucursal_promociones
                },
                set(value) {
                    this.$store.commit('set_filtro_sucursal_promociones', value)
                }
            }
        },
        data() {
            return {
                modal_formulario: false,
                objeto: {},
                modal_editar: false,
                item: {},
            }
        },
        methods: {
            cerrar_modal_formulario() {
                this.modal_formulario = false
            },
            abrir_modal_formulario(item) {
                this.objeto = item
                this.modal_formulario = true
            },
            cerrar_modal_editar() {
                this.modal_editar = false
            },
            abrir_modal_editar(item) {
                this.item = item
                this.modal_editar = true
            },
            obtenerNombreSucursal(codigoSucursal) {
                if (!codigoSucursal) return 'BODEGA CENTRAL';

                const sucursal = this.sucursales.find(s => s.codigo === codigoSucursal || s.id === codigoSucursal);
                return sucursal ? sucursal.nombre : `Sucursal ${codigoSucursal}`;
            },
            eliminar_formula(item) {
                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {

                        let f = {
                            api: `articulos/${item.documentId}`
                        }

                        this.borrar_data(f)
                        this.obtener_articulos()

                    }
                })

            },
            ...mapActions(['borrar_data', 'obtener_articulos']),
            ...mapMutations(['set_filtro_sucursal_promociones'])
        },
        mounted() {
            this.obtener_articulos()
            this.set_filtro_sucursal_promociones('')
        }
    }
</script>

<style>
    .marco_formulas {
        width: 100%;
        height: calc(100vh - 255px);
        border-radius: 4px;
        overflow: auto;
    }

    .boton_agregar_formula {
        position: absolute;
        right: 15px;
        top: 120px;
        z-index: 999;
    }
</style>